import {AWS_BASE_URL, AWS_BUCKET} from "../config/_aws";

export function renderS3Url(organizations, member, entityName, contentUrl) {
    const organization = organizations[member["organization"]];

    return AWS_BASE_URL + AWS_BUCKET + organization["id"] + "_" + organization["name"] + "/" + entityName + "/" + contentUrl;
}